import { ChangeDetectorRef, Component } from "@angular/core";
import { Select } from "@ngxs/store";
import { KeycloakService } from "keycloak-angular";
import { Observable } from "rxjs";
import { UserProfileState } from "src/app/core/user-profile/store/user-profile.state";
import { User } from "../../models/user.model";
import {
  TranslateService,
} from "@ngx-translate/core";
import { NotificationService } from "../../services/notification.service";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";
import {MenuItemEnum} from "../../enums/menu-item.enum";
import {LangEnum} from "../../enums/lang.enum";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent {
  @Select(UserProfileState.selectUser) user$!: Observable<User>;
  menuIsVisible = false;
  langIsVisible = false;
  dropdownIsToggled = false;
  langDropdownIsToggled = false;
  questLogo: string = "header-wide.svg";
  readonly MenuItemEnum = MenuItemEnum;
  readonly LangEnum = LangEnum;
  private readonly hiddenMenuItems: string[] =
    environment.hiddenMenuItems ?? [];
  private readonly hiddenlangs: string[] =
      environment.hiddenLangs ?? [];

  constructor(
    private readonly keycloak: KeycloakService,
    private translate: TranslateService,
    private notificationService: NotificationService,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {
    switch (environment.questInstance) {
      case "cloud":
        this.questLogo = "header-cloud.svg";
        break;
      case "cyber":
      default:
        this.questLogo = "header-wide.svg";
        break;
    }
  }

  isMenuItemVisible(item: MenuItemEnum): boolean {
    return !this.hiddenMenuItems.includes(item);
  }

  isLangVisible(item: LangEnum): boolean {
    return !this.hiddenlangs.includes(item);
  }

  toggleButton() {
    this.menuIsVisible = !this.menuIsVisible;
    this.langIsVisible = false;
    if (!this.menuIsVisible) {
      this.dropdownIsToggled = false;
    }
    this.cdr.detectChanges();
  }

  closeMenu() {
    this.menuIsVisible = false;
    this.langIsVisible = false;
    this.dropdownIsToggled = false;
    this.cdr.detectChanges();
  }

  toggleLang() {
    this.langIsVisible = !this.langIsVisible;
    this.menuIsVisible = false;
    if (!this.langIsVisible) {
      this.dropdownIsToggled = false;
    }
    this.cdr.detectChanges();
  }

  toggleDropdown(event: any) {
    this.dropdownIsToggled = event.detail.visible;
    this.cdr.detectChanges();
  }

  toggleLangDropdown(event: any) {
    this.langDropdownIsToggled = event.detail.visible;
    this.cdr.detectChanges();
  }

  profileClicked() {
    this.dropdownIsToggled = false;
  }

  logout(): void {
    localStorage.removeItem("userToken");
    this.keycloak.logout();
  }

  setLanguage(language: string) {
    sessionStorage.setItem("lang", language);
    this.translate.use(language);
    this.notificationService.showSuccess(
      "Language",
      "Language changed successfully!",
    );
    this.langDropdownIsToggled = false;
    this.langIsVisible = false;
    this.cdr.detectChanges();
    if (this.router.url.includes("/ctf")) {
      window.location.reload();
    }
  }
}
